import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { editMatchedLocationUpdateHeader } from './constants'
import Typography from '@mui/material/Typography'
import { useGetLocationUrl } from '@user/store/authorization/hooks'
import { EditMatchedLocationHeaderContainer } from './EditMatchedLocationHeaderConatiner.styles'

type Props = {
  externalLocationId: string
  isBillTo: boolean
}

export function EditMatchedLocationHeaderUpdate(props: Props) {
  const { externalLocationId, isBillTo } = props
  const locationUrl = useGetLocationUrl(externalLocationId, isBillTo)
  const theme = useTheme()
  return (
    <EditMatchedLocationHeaderContainer
      flexDirection="row"
      justifyContent="space-between"
      paddingLeft={20}
      gap={5}
    >
      <Stack direction="row" alignItems="center">
        <Box display="flex" paddingRight={1} flexBasis={50}>
          <InfoOutlined
            sx={{ color: '#005aa3', marginRight: theme.spacing(0.8) }}
          />
        </Box>
        <Typography>{editMatchedLocationUpdateHeader}</Typography>
      </Stack>
      <Box flexBasis={170} fontFamily="Source Sans Pro Semibold" fontSize={14}>
        <a
          href={locationUrl}
          style={{ whiteSpace: 'nowrap' }}
          target="_blank"
          rel="noreferrer"
          data-test-id="editInPestPacLink"
        >
          {'Edit In PestPac'}
        </a>
      </Box>
    </EditMatchedLocationHeaderContainer>
  )
}
